<template>
  <v-flex xs12>
    <v-layout row wrap>
      <v-flex xs12 sm6>
        <v-layout row wrap>
          <v-flex xs6 sm6 md3 lg2>
            <div class="image_container">
              <img :src="imageFile.ImageData" class="zoom">
              <div class="after faded">
                <p class="black--text full text-left">
                  <v-btn v-if="imageFile.ImageData" icon color="warning" @click="removeFile()">
                    <v-icon>cancel</v-icon>
                  </v-btn>
                </p>
              </div>
            </div>
            <div class="tool-tip">{{toolTip}}</div>
            <v-input
              :value="imageFile">
            <v-btn block color="primary" dark @click="onPickFile" single-line >
              {{btnName}}
            </v-btn>
          </v-input>
          <input type="file" ref="image" name="image" accept="image/*" capture="environment" @change="onFilePicked"/>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import mediumZoom from 'medium-zoom'
import { readAndCompressImage } from 'browser-image-resizer'

export default {
  components: {},
  props: ['imageFile', 'btnName', 'toolTip'],
  data () {
    return {
      // btnName: 'Select',
      // FileItems: null,
      accept: 'image/*',
      authentication: true, // Determines if acceptedFileTypes should prevent submissions from files without those endings
      acceptedFileTypes: ['png', 'jpg']
    }
  },
  mounted () {
    if (process.env.NODE_ENV === 'development') console.log('--> Mounted imageUploader: ', this.imageFile)
    mediumZoom(
      Array.from(document.querySelectorAll('.zoom')).filter(
        img => !img.classList.contains('medium-zoom-image')
      )
    )
  },
  methods: {
    onPickFile () {
      this.$refs.image.click()
    },
    async onFilePicked (event) {
      this.imageFile = event.target.files && event.target.files[0]
      if (process.env.NODE_ENV === 'development') {
        console.log('--> picking file, files: ', event.target.files)
        console.log('--> picking file, imageFile: ', this.imageFile)
      }
      if (this.imageFile) {
        const compressedFile = await readAndCompressImage(this.imageFile, {
          quality: 0.6,
          maxWidth: 1600,
          maxHeight: 1600
        })

        const filename = this.imageFile.name
        const regex = new RegExp(
          '.' + this.acceptedFileTypes.join('|') + '$',
          'i'
        )
        if (this.authentication) {
          if (filename && !filename.match(regex)) {
            this.$root.$message.showError(this.$t('File must be an image (jpg or png)'))
            event.target.value = ''
            return
          }
        }
        const fileReader = new FileReader()
        fileReader.addEventListener('load', () => {
          if (process.env.NODE_ENV === 'development') console.log('--> file loaded, fileReader: ', fileReader)
          this.imageFile.ImageData = fileReader.result
          this.imageFile.NameOfFile = filename
          this.$emit('imageChange', this.imageFile)

          this.$nextTick(() => {
            mediumZoom(
              Array.from(document.querySelectorAll('.zoom')).filter(
                img => !img.classList.contains('medium-zoom-image')
              )
            )
          }, 0)
        })
        fileReader.readAsDataURL(compressedFile)
      } else {
        this.$store.dispatch('notify', {
          message: 'No file provided',
          color: 'error'
        })
        event.target.value = ''
      }
    },
    removeFile () {
      this.imageFile.ImageData = null
      this.imageFile.NameOfFile = ''
      this.$emit('imageChange', this.imageFile)
    }
  }
}
</script>

<style scoped>
input[type='file'] {
  position: absolute;
  left: -99999px;
}
.image_container {
  position: relative;
  display: inline-block;
  text-align: center;
}
.image_container img {
  max-width: 100%;
}
.image_container .after {
  position: absolute;
  top: 0;
  left: 0;
}
.faded {
  opacity: 0.75;
}
.tool-tip {
    font-size: 10px;
}
</style>
